<template>
  <div>
    <v-row :no-gutters="noGutters">
      <!-- Palas -->
      <v-col cols="12" v-for="(blade, i) in blades" :key="blade.id">
        <v-row justify="space-around">
          
          <v-col cols="12" class="headline font-weight-bold">
            2.{{ parseInt(i + 1) }}. Pala {{ blade }}
          </v-col>

          <!-- Datos de los daños -->
          <v-col cols="10" >
            <data-damage inspection :damages="preview.blades[blade].damages" />
          </v-col>

        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DataDamage from "./DataDamage";

export default {
  props: {
    noGutters: { type: Boolean, default: false },
    preview: { type: Object, default: () => {} },
    blades: { type: Array, default: () => [] }
  },
  components: {
    DataDamage
  }
}
</script>
